// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.over_all_general_settings_wrapper {
    padding: 20px;
}

.general_settings_wrapper {
    margin-bottom: 20px;
}

.general_settings_wrapper .form-label {
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}

.general_settings_wrapper .form-control {
    border-radius: 6px;
    border: 1px solid #ddd;
    padding: 10px 15px;
    font-size: 14px;
    transition: border-color 0.3s ease;
}

.general_settings_wrapper .form-control:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.general_settings_btn_wrapper {
    margin-top: 30px;
    text-align: left;
}

.general_settings_btn_wrapper .btn-primary {
    background-color: #007bff;
    border-color: #007bff;
    padding: 10px 30px;
    font-weight: 600;
    border-radius: 6px;
    transition: background-color 0.3s ease;
}

.general_settings_btn_wrapper .btn-primary:hover {
    background-color: #0056b3;
    border-color: #0056b3;
}

.form-check {
    margin-top: 10px;
}

.form-check-input {
    margin-top: 0.25rem;
}

.form-check-label {
    margin-left: 8px;
    color: #555;
}

.errorMessage {
    margin-top: 5px;
}

.select_store {
    padding: 40px;
    text-align: center;
    color: #666;
    font-size: 16px;
}

/* Footer Logo Upload Styles */
.footer_logo_upload_section {
    border-radius: 10px;
    border: 1px dashed;
    height: 100px;
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.footer_logo_upload_section:hover {
    background-color: #fbfbfb;
}

.selected_logo_preview {
    position: relative;
    display: block;
    height: 100px;
    width: 100px;
    padding: 5px;
}

.footer_logo_preview {
    height: 100%;
    width: 100%;
    object-fit: contain;
    border-radius: 10px;
}

.logo_actions {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.logo_actions .btn {
    padding: 2px 6px;
    font-size: 10px;
    line-height: 1.2;
    border-radius: 5px;
    min-width: 60px;
}

.upload_logo_placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.upload_icon {
    cursor: pointer;
    color: #d5d5d5;
    transition: color 0.3s ease;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.upload_icon:hover {
    color: #007bff;
}

.upload_icon svg {
    width: 50px;
    height: 50px;
    margin-bottom: 8px;
}

.upload_icon p {
    margin: 5px 0 3px 0;
    font-weight: 600;
    color: #333;
    font-size: 12px;
    line-height: 1.1;
    text-align: center;
}

.upload_icon small {
    color: #6c757d;
    font-style: italic;
    font-size: 10px;
    display: block;
    text-align: center;
}

.upload_loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    height: 100%;
    justify-content: center;
}

.upload_loading p {
    margin: 0;
    font-size: 12px;
    color: #007bff;
    line-height: 1.1;
}

.upload_loading .spinner-border {
    width: 20px;
    height: 20px;
}

/* Delete overlay styles similar to ImagesPreview */
.delete_overlay {
    position: absolute;
    top: 5px;
    height: 90px;
    width: 90px;
    border-radius: 10px;
    opacity: 0.8;
    cursor: pointer;
    background-color: #e1fdff;
    transition: 0.3s;
}

.delete_overlay:hover {
    opacity: 0.9;
}

.trash_icon_show {
    opacity: 0;
    height: 90px;
    width: 90px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.delete_overlay:hover .trash_icon_show {
    opacity: 1;
    transition: 0.3s;
}

.trash_icon_show i {
    font-size: 25px;
    color: rgb(132, 132, 132);
    margin: 6px;
}

.trash_icon_show i:hover {
    color: #ff6b6b;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/SettingsPage/GeneralSettingsPage/GeneralSettingsPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,mDAAmD;AACnD;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".over_all_general_settings_wrapper {\n    padding: 20px;\n}\n\n.general_settings_wrapper {\n    margin-bottom: 20px;\n}\n\n.general_settings_wrapper .form-label {\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 8px;\n}\n\n.general_settings_wrapper .form-control {\n    border-radius: 6px;\n    border: 1px solid #ddd;\n    padding: 10px 15px;\n    font-size: 14px;\n    transition: border-color 0.3s ease;\n}\n\n.general_settings_wrapper .form-control:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.general_settings_btn_wrapper {\n    margin-top: 30px;\n    text-align: left;\n}\n\n.general_settings_btn_wrapper .btn-primary {\n    background-color: #007bff;\n    border-color: #007bff;\n    padding: 10px 30px;\n    font-weight: 600;\n    border-radius: 6px;\n    transition: background-color 0.3s ease;\n}\n\n.general_settings_btn_wrapper .btn-primary:hover {\n    background-color: #0056b3;\n    border-color: #0056b3;\n}\n\n.form-check {\n    margin-top: 10px;\n}\n\n.form-check-input {\n    margin-top: 0.25rem;\n}\n\n.form-check-label {\n    margin-left: 8px;\n    color: #555;\n}\n\n.errorMessage {\n    margin-top: 5px;\n}\n\n.select_store {\n    padding: 40px;\n    text-align: center;\n    color: #666;\n    font-size: 16px;\n}\n\n/* Footer Logo Upload Styles */\n.footer_logo_upload_section {\n    border-radius: 10px;\n    border: 1px dashed;\n    height: 100px;\n    width: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.footer_logo_upload_section:hover {\n    background-color: #fbfbfb;\n}\n\n.selected_logo_preview {\n    position: relative;\n    display: block;\n    height: 100px;\n    width: 100px;\n    padding: 5px;\n}\n\n.footer_logo_preview {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    border-radius: 10px;\n}\n\n.logo_actions {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.logo_actions .btn {\n    padding: 2px 6px;\n    font-size: 10px;\n    line-height: 1.2;\n    border-radius: 5px;\n    min-width: 60px;\n}\n\n.upload_logo_placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.upload_icon {\n    cursor: pointer;\n    color: #d5d5d5;\n    transition: color 0.3s ease;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.upload_icon:hover {\n    color: #007bff;\n}\n\n.upload_icon svg {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 8px;\n}\n\n.upload_icon p {\n    margin: 5px 0 3px 0;\n    font-weight: 600;\n    color: #333;\n    font-size: 12px;\n    line-height: 1.1;\n    text-align: center;\n}\n\n.upload_icon small {\n    color: #6c757d;\n    font-style: italic;\n    font-size: 10px;\n    display: block;\n    text-align: center;\n}\n\n.upload_loading {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    height: 100%;\n    justify-content: center;\n}\n\n.upload_loading p {\n    margin: 0;\n    font-size: 12px;\n    color: #007bff;\n    line-height: 1.1;\n}\n\n.upload_loading .spinner-border {\n    width: 20px;\n    height: 20px;\n}\n\n/* Delete overlay styles similar to ImagesPreview */\n.delete_overlay {\n    position: absolute;\n    top: 5px;\n    height: 90px;\n    width: 90px;\n    border-radius: 10px;\n    opacity: 0.8;\n    cursor: pointer;\n    background-color: #e1fdff;\n    transition: 0.3s;\n}\n\n.delete_overlay:hover {\n    opacity: 0.9;\n}\n\n.trash_icon_show {\n    opacity: 0;\n    height: 90px;\n    width: 90px;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.delete_overlay:hover .trash_icon_show {\n    opacity: 1;\n    transition: 0.3s;\n}\n\n.trash_icon_show i {\n    font-size: 25px;\n    color: rgb(132, 132, 132);\n    margin: 6px;\n}\n\n.trash_icon_show i:hover {\n    color: #ff6b6b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
